export default __webpack_public_path__ + "static/media/batteryLevel.1895c3bc.png";